import user from '../modules/user/types/mutation-types';
import viewContent from '../modules/viewContent/types/mutation-types';
import subHeader from '../modules/subHeader/types/mutation-types';
import editor from '../modules/editor/types/mutation-types';
import mandantEditor from '../modules/mandantEditor/types/mutation-types';
import sharedEditor from '../modules/sharedEditor/types/mutation-types';
import aufgaben from '../modules/aufgaben/types/mutation-types';
import mandanten from '../modules/mandanten/types/mutation-types';
import shopAdmin from '../modules/shopAdmin/types/mutation-types';
import shopClient from '../modules/shopClient/types/mutation-types';
import shopInfo from '../modules/shopInfo/types/mutation-types';

const TYPES = {
  user,
  viewContent,
  subHeader,
  editor,
  mandantEditor,
  sharedEditor,
  aufgaben,
  mandanten,
  shopAdmin,
  shopClient,
  shopInfo,
};

export default TYPES;
